import * as React from 'react';
import InfoIconUI from '../InfoIcon/InfoIconUI';

const showNotAvailableText = (value, notAvailableText) => {
    return value === null && notAvailableText;
};

const getValueText = (value, notAvailableText) => {
    return showNotAvailableText(value, notAvailableText) ? notAvailableText : value;
};

const getValueClassName = (value, notAvailableText) => {
    let valueClassName = 'field-value';
    if (showNotAvailableText(value, notAvailableText)) {
        valueClassName += ' not-available';
    }
    return valueClassName;
};

export interface ILineItemUIStateProps {
    id: string;
    label: string;
    value: string;
    notAvailableText?: string;
    showToolTip?: boolean;
}

export interface ILineItemUIDispatchProps {
    onClickEvent?: { (): void };
}

export interface ILineItemUIProps extends ILineItemUIStateProps, ILineItemUIDispatchProps { }

export const LineItemUI: React.ComponentType<ILineItemUIProps> = (props: ILineItemUIProps) => {
    const valueClassName = getValueClassName(props.value, props.notAvailableText);
    const valueText = getValueText(props.value, props.notAvailableText);
    return valueText && props.label ? (
        <div className="line-item" id={props.id}>
            <span className="field-label">{props.label.replace('&amp;', '&')}</span>
            {props.showToolTip ? (
                <div className="adjusted-cashdown-container">
                    <InfoIconUI onIconClick={props.onClickEvent} />
                    <span className={`${valueClassName} adjusted-cashdown-text`}>{valueText}</span>
                </div>
            ) : (
                <span className={valueClassName}>{valueText}</span>
            )}
        </div>
    ) : null;
};

export interface IGroupLineItemUIProps {
    id: string;
    label: string;
    notAvailableText?: string;
    showSeparator?: boolean;
    value: string;
}

export const GroupLineItemUI: React.ComponentType<IGroupLineItemUIProps> = ({
    label,
    value,
    notAvailableText,
    id,
    showSeparator
}) => {
    const valueClassName = getValueClassName(value, notAvailableText);
    const valueText = getValueText(value, notAvailableText);
    return valueText ? (
        <>
            {showSeparator && <hr />}
            <div className="line-item sub-total" id={id}>
                <label className="field-label">{label}</label>
                <span className={valueClassName}>{valueText}</span>
            </div>
        </>
    ) : null;
};
